var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c("div", { staticClass: "level-item" }, [
            _c("p", { staticClass: "title is-4" }, [
              _vm._v(
                "\n          Appointment Times - all times are " +
                  _vm._s(_vm.displayedTimezone) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.suiteCount < 3
        ? _c("div", { staticClass: "tabs is-medium" }, [
            _c(
              "ul",
              _vm._l(_vm.sortedSuiteKeys, function(key, idx) {
                return _c(
                  "li",
                  {
                    key: idx,
                    class: _vm.activeSuiteKey === key ? "is-active" : "",
                    on: {
                      click: function($event) {
                        _vm.activeSuiteKey = key
                      }
                    }
                  },
                  [
                    _c("a", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.suites[key].name) +
                          "\n        "
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ])
        : _c("div", [
            _c("div", { staticClass: "select mb-4 ml-8" }, [
              _c(
                "select",
                {
                  on: {
                    change: function($event) {
                      _vm.activeSuiteKey = $event.target.value
                    }
                  }
                },
                _vm._l(_vm.sortedSuiteKeys, function(key, idx) {
                  return _c(
                    "option",
                    {
                      key: idx,
                      class: _vm.activeSuiteKey === key ? "is-active" : "",
                      domProps: {
                        value: key,
                        selected: _vm.activeSuiteKey === key
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.suites[key].name) +
                          "\n        "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
      _vm._v(" "),
      _vm._l(_vm.suites, function(suite, key) {
        return _vm.activeSuiteKey === key
          ? _c("schedule", {
              key: key,
              attrs: {
                id: _vm.id,
                suiteId: key,
                isSuiteWriteable: !!_vm.writeableSuites.filter(function(suite) {
                  return suite === key
                }).length
              }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1897032c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1897032c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attendees/UserSuites.vue
// module id = null
// module chunks = 